import { Button } from "@kirvanobr/button";
import { Typography } from "@kirvanobr/typography";

import { FilterProps } from "./Filters.types";

import { FilterChip } from ".";

export const Filters = ({ activeFilters, onClear, onRemoveByName }: FilterProps) => {
  return (
    <section className="flex gap-2 flex-wrap md:flex-nowrap items-center">
      <div className="flex flex-col md:mt-1">
        <Typography weight="bold" variant="subtitle" size="t4">
          FILTROS
        </Typography>
        <Typography weight="bold" variant="subtitle" size="t4">
          ATIVOS:
        </Typography>
      </div>
      <div className="flex gap-2 flex-wrap">
        {activeFilters &&
          activeFilters.map((filter, index) => (
            <FilterChip key={index} onClose={() => onRemoveByName(filter.field)} data={filter} />
          ))}
      </div>
      {activeFilters && activeFilters.length > 0 && (
        <Button variant="link" color="primary" disableRipple onClick={onClear} size="sm" className="font-bold">
          Limpar filtros
        </Button>
      )}
    </section>
  );
};
